module.exports = __webpack_public_path__ + "img/page_image_2_2.a3e55303.svg";